<template>
  <v-container class="pa-10">
    <list></list>
  </v-container>
</template>

<script>
import List from "../components/shopping/List.vue";
export default {
  components: { List },
};
</script>

<style>
</style>